// 获取 年,月,日,小时、分钟和秒
function getCurrentTime(value) {
  const now = new Date(value);
  // 获取年、月、日、小时、分钟和秒
  const year = now.getFullYear();
  const month = (now.getMonth() + 1).toString().padStart(2, '0'); // 月份从 0 开始，所以要加 1
  const day = now.getDate().toString().padStart(2, '0');
  const hours = now.getHours().toString().padStart(2, '0');
  const minutes = now.getMinutes().toString().padStart(2, '0');
  const seconds = now.getSeconds().toString().padStart(2, '0');

  // 返回格式化的日期时间字符串
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

function get_time_year_month_day(value) {
  const now = new Date(value);
  // 获取年、月、日、小时、分钟和秒
  const year = now.getFullYear();
  const month = (now.getMonth() + 1).toString().padStart(2, '0'); // 月份从 0 开始，所以要加 1
  const day = now.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}
export { getCurrentTime ,get_time_year_month_day};
